import { LocaleCode } from '@nuklear9/i18n';
import { graphql, useStaticQuery } from 'gatsby';

export const useBranches = (locale: LocaleCode): Array<any> => {
  const { allDrupalBranch } = useStaticQuery<BranchTermsQuery>(graphql`
    query BranchTerms {
      allDrupalBranch {
        nodes {
          langcode
          title
          drupalId
          depth
        }
      }
    }
  `);

  return allDrupalBranch?.nodes
    ? allDrupalBranch?.nodes.filter((item: any) => item.langcode === locale && item.depth ===  0) : [];
};
